import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class FileServiceModerator {
  constructor(private _http: HttpClient) {
  }

  uploadFile(formData: FormData) {
    return this._http.post<any>(`api/file/upload/v2`, formData, {headers: {'noContentType': 'true'}});
  }

  deleteFile(id: any) {
    return this._http.delete(`api/file/delete/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/moderator/services/file-service-moderator.service.ts